<template>
  <div class="footer-menu">
    <van-tabbar router v-model="tabbarActive" placeholder>
      <!--      <van-tabbar-item name="index" icon="home-o" :to="{name:'Index'}">首页</van-tabbar-item>-->
      <van-row class="tab-sub-box">
        <van-col span="8" style="border-right: 1px solid #ececec">
          <van-tabbar-item
            class="width1"
            name="taskHome"
            icon="label-o"
            :to="{ name: 'TaskHome' }"
            >项目广场</van-tabbar-item
          >
        </van-col>
        <van-col span="8" style="border-right: 1px solid #ececec">
          <van-tabbar-item
            name="checkIn"
            icon="photograph"
            :to="{ name: 'CheckIn' }"
            >打卡</van-tabbar-item
          >
        </van-col>
        <van-col span="8">
          <van-tabbar-item
            class=""
            name="mine"
            icon="contact"
            :to="{ name: 'Mine' }"
            >我的</van-tabbar-item
          >
        </van-col>
      </van-row>
    </van-tabbar>


  </div>
</template>
<script>
export default {
  name: 'FooterMenu',
  data () {
    return {
      tabbarActive: 'index',
      activeColor: '#e92504',
      unActiveColor: '#7d7e80'
    }
  },
  created () {
    this.initTabbarIndex()
  },
  methods: {
    initTabbarIndex () {
      const url = this.$route.path
      if (url.indexOf('/taskHome') > -1) {
        this.tabbarActive = 'taskHome'
      }
      if (url.indexOf('/checkIn') > -1) {
        this.tabbarActive = 'checkIn'
      }
      if (url.indexOf('/mine') > -1) {
        this.tabbarActive = 'mine'
      }
    },

  },
  watch: {
    $route (nval, oval) {
      this.initTabbarIndex()
    }
  }
}
</script>
<style scoped>
.tab-sub-box {
  width: 100%;
  display: flex;
  align-items: center;
}
</style>
